export const variantIdsFromHits = (hits) => {
    if (!Array.isArray(hits)) return [];

    return [...new Set(
        hits
            .map((hit) => Number(hit && hit.variant_id))
            .filter((id) => Number.isInteger(id) && id > 0)
    )];
};

export const buildLegacySearchResponse = (smartResponse = {}, hydratedProducts = []) => {
    const variantIds = variantIdsFromHits(smartResponse.hits);
    const productsById = new Map(
        (Array.isArray(hydratedProducts) ? hydratedProducts : [])
            .map((product) => [String(product.id), product])
    );
    const rows = variantIds
        .map((id) => productsById.get(String(id)))
        .filter(Boolean);
    const variants = Array.isArray(smartResponse.variants) ? smartResponse.variants : [];
    const originalQuery = String(smartResponse.query || variants[0] || '').trim().toLowerCase();

    return {
        count: Number.isFinite(Number(smartResponse.found))
            ? Number(smartResponse.found)
            : rows.length,
        rows,
        next_offset: Number.isInteger(smartResponse.next_offset)
            ? smartResponse.next_offset
            : null,
        recognized: variants.filter(
            (variant) => String(variant).trim().toLowerCase() !== originalQuery
        ),
    };
};

export const buildLegacyTips = (smartResponse = {}) => {
    if (!Array.isArray(smartResponse.tips)) return [];

    return smartResponse.tips
        .filter((name) => typeof name === 'string' && name.trim())
        .map((name, index) => ({
            id: `smart-tip-${index}`,
            name,
        }));
};
